import React from 'react';
import Loading from 'components/Loading';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { authStore } from 'stores/authorizationStore';
import simpleDialog from 'stores/simpleDialog';

const GlobalAuthModal = () => {
    useEffect(
        () =>
            autorun(() => {
                if (authStore.pendingAuth) {
                    simpleDialog.info({
                        title: 'Waiting For Authorization',
                        icon: <Loading size={64} style={{ color: '#fff' }} />,
                        text: 'Please confirm the authorization in your wallet.',
                        hideAllButton: true,
                    });
                } else {
                    simpleDialog.close();
                }
            }),
        [],
    );

    return null;
};

export default observer(GlobalAuthModal);
